<template>
  <autocomplete-filter v-model="selectedProjects" :items="projectsList" item-value="id"
                       :label="$t('MULTIPROJECTS.PROJECTS')" :placeholder="selectedProjects.length ? '' : $t('MULTIPROJECTS.NO_PROJECT_SELECTED')"
                       v-model:search="searchInput" :prepend-inner-icon="smallScreen ? null : 'far fa-folder-open'" multiple :menu-props="{ location: 'bottom' }"
                       @update:model-value="update">
    <template #prepend-item>
      <filter-toggle :selected-ids="selectedProjects" :sublist-ids="projectIds"
                     @update="selectedProjects = $event; update()">
        {{ $t('MULTIPROJECTS.ALL_PROJECTS') }} ({{ projectIds.length }})
      </filter-toggle>
      <v-divider></v-divider>
      <v-list-group v-if="projectCategories.length && ! customProjectsFilters" fluid>
        <template #activator="{ props }">
          <v-list-item v-bind="props">
            <v-list-item-title class="ml-4">{{ $t('PROJECTS.CATEGORY', 2) }}</v-list-item-title>
          </v-list-item>
        </template>
        <filter-toggle v-for="category in filteredProjectCategories" :key="category"
                       :selected-ids="selectedProjects" :sublist-ids="projectIdsByCategory[category]" indent dense
                       @update="selectedProjects = $event; update()">
          <project-category :category="category" pointer></project-category> <span style="vertical-align: middle">({{ projectIdsByCategory[category].length }})</span>
        </filter-toggle>
        <v-divider></v-divider>
      </v-list-group>
    </template>
    <template #selection="{ item: { raw: item }, index }">
      <span v-if="selectedProjects.length == 1" class="text-ellipsis">{{ item.title }}</span>
      <span v-else-if="selectedProjects.length == projects.length && index === 0" class="text-ellipsis">{{ $t('MULTIPROJECTS.ALL_PROJECTS') }} ({{ projects.length }})</span>
      <span v-else-if="index === 0" class="text-ellipsis">{{ selectedProjects.length }}/{{ projects.length }}</span>
    </template>

    <template #append>
      <client-custom-component v-if="customProjectsFilters" :name="customProjectsFilters.component" v-model="customProjectsFilters.value" :project-ids-by-category="projectIdsByCategory"
                               @update="selectedProjects = $event; update()" @reset="selectedProjects = projectIds; update()">
      </client-custom-component>
      <v-btn size="small" color="secondary" icon @click="reload()">
        <v-icon>far fa-sync-alt</v-icon>
        <v-tooltip location="bottom" activator="parent">
          {{ $t('MULTIPROJECTS.REFRESH_PROJECTS') }}
        </v-tooltip>
      </v-btn>
    </template>
  </autocomplete-filter>
</template>

<script>
  import { mapState, mapActions } from 'pinia';
  import clientConfig from '@/client_customs/config';
  import useMultiprojectsStore, { getProjectIdsByCategory } from '@/stores/multiprojects/multiprojects';
  import ProjectCategory from '@/components/Projects/ProjectCategory';

  export default {
    components: {
      ProjectCategory,
    },
    emits: ['update'],
    data() {
      return {
        searchInput: null,
        customProjectsFilters: clientConfig.dashboards?.customProjectsFilters || null,
        multiprojectsStore: useMultiprojectsStore(),
      };
    },
    computed: {
      selectedProjects: {
        get() {
          return this.multiprojectsStore.selectedProjects;
        },
        set(newVal) {
          this.multiprojectsStore.selectedProjects.splice(0, this.multiprojectsStore.selectedProjects.length, ...newVal);
        },
      },
      projectIds() {
        return this.projects.map(item => item.id).filter(item => item);
      },
      projectIdsByCategory() {
        return getProjectIdsByCategory(this.projects);
      },
      projectCategories() {
        return Object.keys(this.projectIdsByCategory).sort((a, b) => {
          return (a || "").toLowerCase() < (b || "").toLowerCase() ? -1 : 1;
        });
      },
      filteredProjectCategories() {
        if (! this.searchInput) return this.projectCategories;
        const searchInputLowerCase = this.searchInput.toLowerCase();
        return this.projectCategories.filter(item => (item || "").toLowerCase().includes(searchInputLowerCase));
      },
      projectsList() {
        return this.projects.map(project => ({ id: project.id, title: project.meta?.title || this.$t('PLANNING.UNNAMED_PROJECT') }));
      },
      smallScreen() { return this.$vuetify.display.mdAndDown; },
      ...mapState(useMultiprojectsStore, ['projects']),
    },
    methods: {
      update() {
        this.$emit('update');
      },
      ...mapActions(useMultiprojectsStore, ['reload']),
    },
  };
</script>
